import { ConnectUser } from "./api/ConnectApi"

export interface Organization {
  id: string
  name: string
}

export interface User {
  id: string
  name: string
  organization: Organization
}

export type ActivityType = "Share" | "Receive" | "Join" | "Reserve" | "Release"

export interface Activity {
  type: ActivityType
  time: string
  // user: User
  userId: string
  description?: string
  tasksAffectedCount?: number // Applicable to Share, Receive ++ ?
  worksetName?: string // Applicable to Join
  taskChanges?: {
    taskId: string
    changeType: string
    taskName: string
    taskType: string
  }[]
  secondsSpent?: number
  activityId?: string
  isImplicit?: boolean
}

export interface ActivitiesFilter {
  tidUserIds?: string[]
  startDate?: string
  endDate?: string
}

export type TaskSelected = string

export type TaskSidebar = {
  taskName: string
  taskId: number
  guid: string
  subTaskIds: string[]
  clickedTaskId: number
  createdData: string
  lastModifiedData: string
  includeDeleted: boolean
}

export interface TasksFilter {
  nameSearch?: string
  connectUserIds?: string[]
  startDate?: string
  endDate?: string
  showDeletedTask?: boolean
  includeDeleted: boolean
}

export interface TimelineSidebar {
  activity: Activity
  users: { [key: string]: ConnectUser }
  quadriProjectId: string
}

// export type WorksetSidebar = WorksetType

export interface WorksetSidebar extends WorksetType {
  fullName: string
}

export interface WorksetType {
  id: string
  name: string
  status: WorksetStatusType
  userId: string
  createdTime: string
  reservedTaskIds?: string[]
  reservedTasks?: {
    name: string
    taskPath: {
      name: string
      taskPath: {
        name: string
      }
    }
  }[]
  reservedFeatures?: {
    featureTypeName: string
  }[]
  activity?: {
    type: string
    description: string
    time: string
  }[]
}

export enum WorksetStatusType {
  Connected = "Connected",
  Disconnected = "Disconnected"
}

export interface QuadriProject {
  connectProjectId?: string
  featureCatalogId?: string
  projectStatus?: QuadriProjectStatusType
  projectStatusMessage?: string
  createdAt?: string
  updatedAt?: string
  deletedAt?: string
}

export type ProjectStatus = "Creating" | "Active" | "Failed" | "Updating" | "Deleting"

export type CoordinateSystemUnit = "Meter" | "UsSurveyFoot" | "InternationalFoot"

export type ProjectCreatedWithStatus = "Unspecified" | "Created" | "NotCreated" | "CreatedWithoutArea"

// TODO: REMOVE
export enum QuadriProjectStatusType {
  Creating = "Creating",
  Active = "Active",
  Failed = "Failed",
  Updating = "Updating" // TODO: not implemented elsewhere yet
}

export interface FeatureCatalogInfo {
  id: string
  name: string
  standard: string
  version: string
  date: string
  displayText: string
}

export interface FeatureCatalogStandard {
  id: string
  name: string
}

export interface HasAccessReply {
  access: boolean
}

export enum ConnectProjectRegion {
  northAmerica = "northAmerica",
  europe = "europe",
  asia = "asia",
  australia = "australia"
}

export interface CreateProjectRequest {
  connectProjectId: string
  featureCatalogId: string
  connectProjectRegion: ConnectProjectRegion
  coordinateSystemUnit: CoordinateSystemUnit
  customerAccountId: string
}

export interface Notification {
  title: string
  description: string
  pubDate: string
  link: string
  guid: string
}

export interface Point {
  latitude: number
  longitude: number
}
